import { render, staticRenderFns } from "./user-project-img.vue?vue&type=template&id=46704063&"
import script from "./user-project-img.vue?vue&type=script&lang=ts&"
export * from "./user-project-img.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports